import { useRouter } from "components/Router"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { useTranslator } from "components/Translator"
import { Card, CardActionArea, CardMedia, CardContent } from "components/Card"
import NoImagePlaceholder from "components/NoImagePlaceholder/NoImagePlaceholder.png"
import { Text } from "components/Text"
import { Anchor, Pen } from "components/Icon"
import { Separator } from "components/Separator"
import { Button } from "components/Button"
import { Image } from "components/Image"
import { BoatDeleteButton } from "./BoatDeleteButton"
import { BoatHeader } from "domains/boat/BoatHeader"
import { BoatDate } from "domains/boat/BoatDate"
import { formatAddress } from "utils/formatAddress"

export const BoatCard = ({ boat, ownerId, onDelete }) => {
  const router = useRouter()
  const connectedUser = useConnectedUser()
  const translator = useTranslator()

  return (
    <Card>
      <CardActionArea
        href={router.generate("app_account_boat_show", {
          boatId: boat.id,
          userId: boat.user?.id || ownerId,
        })}
      >
        {boat.imageFile ? (
          <CardMedia
            media={
              <Image
                imageFile={boat.imageFile}
                size="w640"
                className="object-cover"
              />
            }
            className="h-48"
          />
        ) : (
          <img src={NoImagePlaceholder} alt="" loading={"lazy"} />
        )}
        <CardContent>
          <div className="space-y-2">
            <div className="space-y-2">
              <BoatHeader boat={boat} />
              <div className="flex flex-col space-y-2">
                <Text className="text-default" variant="caption">
                  <BoatDate boat={boat} />

                  {boat.nbVisits ? (
                    <span>
                      • {boat.nbVisits}{" "}
                      {translator.trans(
                        "account.boat.show.views",
                        null,
                        "pages",
                      )}
                    </span>
                  ) : null}
                </Text>
              </div>
            </div>
            {boat.address?.formatted ? (
              <div className="flex flex-row space-x-2 items-center">
                <Anchor className="text-primary-default w-6" />
                <Text variant="body2" aria-label="Port du bateau">
                  {formatAddress(boat.address)}
                </Text>
              </div>
            ) : null}
            {boat.completionRate ? (
              <Text variant="caption">{boat.completionRate}%</Text>
            ) : null}
          </div>
        </CardContent>
      </CardActionArea>
      {ownerId && connectedUser?.id === ownerId ? (
        <>
          <Separator />
          <CardContent>
            <div className="flex flex-col space-y-2">
              <Button
                variant="outline"
                color="secondary"
                href={router.generate("app_user_boat_edit", {
                  boatId: boat.id,
                })}
                iconLeft={<Pen className="w-4" />}
              >
                {translator.trans("account.boat.index.edit", null, "pages")}
              </Button>
              <BoatDeleteButton
                boat={boat}
                onDelete={onDelete}
                variant="text"
              />
            </div>
          </CardContent>
        </>
      ) : null}
    </Card>
  )
}
